/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserDTO } from '../models/CreateUserDTO';
import type { InviteUserDTO } from '../models/InviteUserDTO';
import type { UpdateUserDTO } from '../models/UpdateUserDTO';
import type { UserDTO } from '../models/UserDTO';
import type { UserListDTO } from '../models/UserListDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BackOfficeUserService {

    /**
     * Add user to workspace
     * @param workspaceId
     * @param requestBody InviteUserDTO
     * @returns any Successful response
     * @throws ApiError
     */
    public static backOfficeUserControllerAddUserToWorkspace(
        workspaceId: string,
        requestBody?: InviteUserDTO,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users/add-to-workspace',
            path: {
                'workspaceId': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Archive
     * @param workspaceId
     * @param id
     * @returns UserDTO
     * @throws ApiError
     */
    public static backOfficeUserControllerArchive(
        workspaceId: string,
        id: string,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users/{id}/archive',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
        });
    }

    /**
     * Create
     * @param workspaceId
     * @param requestBody CreateUserDTO
     * @returns UserDTO
     * @throws ApiError
     */
    public static backOfficeUserControllerCreate(
        workspaceId: string,
        requestBody?: CreateUserDTO,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users',
            path: {
                'workspaceId': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Search
     * @param workspaceId
     * @param email
     * @param firstName
     * @param lastName
     * @param pageNumber
     * @param pageSize
     * @param status
     * @returns UserListDTO
     * @throws ApiError
     */
    public static backOfficeUserControllerSearch(
        workspaceId: string,
        email?: string,
        firstName?: string,
        lastName?: string,
        pageNumber?: number,
        pageSize?: number,
        status?: 'ACTIVE' | 'ARCHIVED' | 'DELETED',
    ): CancelablePromise<UserListDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/back-office/workspaces/{workspaceId}/users',
            path: {
                'workspaceId': workspaceId,
            },
            query: {
                'email': email,
                'firstName': firstName,
                'lastName': lastName,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'status': status,
            },
        });
    }

    /**
     * Delete
     * @param workspaceId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    public static backOfficeUserControllerDelete(
        workspaceId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/back-office/workspaces/{workspaceId}/users/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
        });
    }

    /**
     * Read one
     * @param workspaceId
     * @param id
     * @returns UserDTO
     * @throws ApiError
     */
    public static backOfficeUserControllerReadOne(
        workspaceId: string,
        id: string,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/back-office/workspaces/{workspaceId}/users/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
        });
    }

    /**
     * Update
     * @param workspaceId
     * @param id
     * @param requestBody UpdateUserDTO
     * @returns UserDTO
     * @throws ApiError
     */
    public static backOfficeUserControllerUpdate(
        workspaceId: string,
        id: string,
        requestBody?: UpdateUserDTO,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/back-office/workspaces/{workspaceId}/users/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * User import operation, a maximum of 10 users is supported
     * @param workspaceId
     * @returns any Successful response
     * @throws ApiError
     */
    public static backOfficeUserControllerImportUsers(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users/import',
            path: {
                'workspaceId': workspaceId,
            },
        });
    }

    /**
     * Remove from workspace
     * @param workspaceId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    public static backOfficeUserControllerRemoveFromWorkspace(
        workspaceId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users/{id}/remove-from-workspace',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
        });
    }

    /**
     * Reset password
     * @param workspaceId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    public static backOfficeUserControllerResetPassword(
        workspaceId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users/{id}/reset-password',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
        });
    }

    /**
     * Unarchive
     * @param workspaceId
     * @param id
     * @returns UserDTO
     * @throws ApiError
     */
    public static backOfficeUserControllerUnarchive(
        workspaceId: string,
        id: string,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back-office/workspaces/{workspaceId}/users/{id}/unarchive',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
        });
    }

}
